// Tunables for the recessed-light layout engine. One line of rationale each;
// values decided in claude-docs/2026-08-06-recessed-light-layout-design.md §8.
module.exports = {
  EDGE_OFFSET: 0.76, // 2.5 ft — perimeter row offset from each edge
  PERIMETER_SPACING: 1.83, // 6 ft — can spacing along an edge row
  MIN_EDGE_CLEARANCE: 0.6, // 2 ft — hard minimum distance to any polygon edge
  MIN_CAN_SEPARATION: 1.2, // 4 ft — dedupe distance between kept cans
  INTERIOR_THRESHOLD: 1.83, // 6 ft — distance from edges defining the interior region
  INTERIOR_SPACING_BASE: 2.44, // 8 ft — base interior grid spacing
  MAX_INTERIOR_CANS: 12, // interior count cap (widens spacing when exceeded)
  HIGH_MOUNT_MIN_BOTTOM: 1.2, // m — object bottom above this ⇒ wall-mounted obstruction
  TALL_TOP_GAP: 0.6, // m — object top within this of the ceiling ⇒ tall obstruction
  OBSTRUCTION_MARGIN: 0.15, // m — obstruction footprint inflation per side
  MAX_SHIFT: 0.45, // 1.5 ft — max obstruction nudge before dropping a can
  // Steepest ceiling facet that receives cans. 60° covers adjustable/gimbal
  // sloped-ceiling trims (fixed housings top out ~45°) and matches the
  // engine's facet-participation bound (ceilingSeat MIN_HORIZONTAL_NY = 0.5
  // ⇔ 60°), so per-call overrides only make sense at or below 60.
  MAX_SLOPE_DEG: 60,
};
